export const FORM_LABEL_CHARACTER_LIMIT = {
  mobile: 40,
  default: 75,
};

export const FIELD_OPTIONS_THRESHOLD = 30;
